// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vgPUb","toggle":"styles_toggle__3ppgU","preview":"styles_preview__2gCj7"};